import React, { memo } from 'react'
import withStyles from '@material-ui/core/styles/withStyles'
import TextWithLinks from 'root/src/client/web/base/TextWithLinks'

const styles = {
	fontStyle: {
		fontSize: 16,
		lineHeight: 1.2,
		marginBottom: 15,
	},
}

export const BodyUnstyled = memo((({ children }) => (
	<TextWithLinks text={children} />
)))

export default withStyles(styles, { name: 'MuiTypographyBody' })(BodyUnstyled)
